import React, { useState, useEffect } from "react";
import { ConnectWallet, useAddress, useDisconnect, useSDK } from "@thirdweb-dev/react";

import { supabase } from "./supabaseClient";

const WalletConnect = () => {
  const address = useAddress();
  const disconnectWallet = useDisconnect();
  const sdk = useSDK();

  const [hasNFT, setHasNFT] = useState(false); // Whether the wallet owns NFTs
  const [loading, setLoading] = useState(true); // Loading state
  const [nftDetails, setNftDetails] = useState([]); // List of NFT details (name and ID)
  const [firebaseConnected, setFirebaseConnected] = useState(false);
  const [supabaseRecord, setSupabaseRecord] = useState(null); // Supabase record for NFT ID
  const [error, setError] = useState(null); // Error handling
  const [id, setId] = useState("");
  const [howTo, setHowto] = useState(false);

  // Replace this with your NFT collection's contract address
  const nftCollectionAddress = "0xb0eAB36beB4cC8EF431b193af53E903B14044185";
  useEffect(() => {
    if (address) {
      // checkFirebase();
      checkNFT(); // Check NFT ownership
    }
  }, [address]);

  // const checkFirebase = async () => {
  //   const connected = await testFirebaseConnection();
  //   console.log(connected)
  //   setFirebaseConnected(connected);
  // };

  const checkNFT = async () => {
    if (!address) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true); // Start loading
      const contract = await sdk.getContract(nftCollectionAddress);
      const nfts = await contract.erc721.getOwned(address); // Get all NFTs owned by the wallet

      if (nfts.length > 0) {
        setHasNFT(true);
        const details = nfts.map((nft) => ({
          id: nft.metadata.id,
          name: nft.metadata.name || "Unnamed NFT", // Use name if available, otherwise fallback
        }));
        setNftDetails(details);
        // Check NFT ID against Supabase
        if (details.length > 0) {
          const nftId = details[0].id; // Take the first NFT's ID (adjust as needed)
          checkSupabase(nftId);
        }
        
      } else {
        setHasNFT(false);
        setNftDetails([]);
      }
    } catch (error) {
      console.error("Error checking NFT ownership:", error);
      setHasNFT(false);
      setNftDetails([]);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    checkNFT();
  }, [address]);

    const checkSupabase = async (id) => {
      try {
        const { data, error } = await supabase
          .from("codes") // Table name
          .select("*") // Fetch all columns
          .eq("id", id) // Check if the NFT ID exists
          .single(); // Expect a single result

        if (error) throw error;

        setSupabaseRecord(data); // Store the record
        setError(null); // Clear any previous errors
      } catch (err) {
        console.error("Error fetching record from Supabase:", err);
        setSupabaseRecord(null);
        setError("No record found for this NFT ID.");
      }
    };
    const handleClick = () => {
      const url = "https://thepitking.com/index.html"; // Replace with your desired URL
      window.location.replace(url);
    };
    const handleClick2 = () => {
      const url = "https://thepitking.com/index.html"; // Replace with your desired URL
      window.location.assign(url);
    };


  return (
    <div className="walletconnect-page">
    <div className="walletconnect-content"> 
      {address ? (
          <div className="main-landing">
          <div className="landing-class">
          <div className="row landing-img">
          <img src="/landing-logo.gif" alt="image" style={{ width: "40%", height: "auto" }} />
          </div>
          <div className="wallet-border">
          {/* <p>Connected Wallet: {address}</p> */}
          {loading ? '' : hasNFT ? (
            <div>
              <p className="note">!! WRITE THIS CODE DOWN.YOU NEED IT TO ENTER THE PIT.!!</p>
              {/* <ul>
                {nftDetails.map((nft) => (
                  <li key={nft.id}>
                    <strong>Name:</strong> {nft.name} <br />
                    <strong>ID:</strong> {nft.id}
                  </li>
                ))}
              </ul> */}
              {supabaseRecord ? (
                <div style={{ marginTop: "20px"}}>
                  <p style={{ margin: "10px"}}>YOUR REGISTRATION CODE IS</p>
                  <p className="code">
                    <strong>{supabaseRecord.code}</strong>
                  </p>
                  <p style={{ marginTop: "20px"}}>YOU MAY NOW</p>
                  <input className="pit-code" placeholder="ENTER THE PIT"
                     type="text" onClick={handleClick}
                  />
                </div>
              ) : error ? (
                <div style={{ marginTop: "20px", color: "red" }}>
                  <p>{error}</p>
                </div>
              ) : null}
            </div>
          ) : (
            <p>You do not own any NFTs from this collection.</p>
          )}
          </div>
          {/* <button onClick={disconnectWallet}>Disconnect Wallet</button> */}
          </div>
          <div className="landing-text">
        ** THE PIT is designed as an engaging, experimental experience. While we endeavor to ensure fair play and optimal performance, unforeseen technical issues or gameplay outcomes may occur. Participants acknowledge that glitches are possible, and that not all players will achieve victory **
        </div>
        </div>
      ) : howTo ? (
        <div className="main-landing">
          <div className="landing-class">
          <div className="row landing-img">
          <img src="/landing-logo.gif" alt="image" style={{ width: "40%", height: "auto" }} />
          </div>
          <div className="how-to">
          <p className="note">!!! YOU MUST WRITE THIS DOWN !!!</p>
          <p  style={{ margin:0}}>1.</p>
          <p style={{ margin:"10px"}}>Connect wallet holding THE PIT NFT and receive your unique registration code. It can only be used ONE TIME.</p>

          <p  style={{ margin:0, paddingTop:'20px'}}>2.</p>
          <p style={{ margin:"10px"}}>Go To the Pit.</p>

          <p  style={{ margin:0, paddingTop:'20px'}}>3.</p>
          <p style={{ margin:"10px", paddingBotoom:'20px'}}>Enter Registeration Code.</p>

          <p onClick={() => setHowto(false)} className="back">Go Back</p>
          </div>
        </div>
        </div>
      )
      : (
        <div className="main-landing">
        <div className="landing-class">
        <div className="row landing-img">
        <img src="/landing-logo.gif" alt="image" style={{ width: "70%", height: "auto" }} />
        </div>
        <div onClick={() => setHowto(true)} className="register-border">How to Register</div>
        <ConnectWallet
         btnTitle="REGISTER" // Custom button text
         className="custom-wallet-button" />
        <div  onClick={handleClick2} className="register-border-2">GO TO THE PIT</div>
        </div>
        <div className="landing-text">
        ** THE PIT is designed as an engaging, experimental experience. While we endeavor to ensure fair play and optimal performance, unforeseen technical issues or gameplay outcomes may occur. Participants acknowledge that glitches are possible, and that not all players will achieve victory **
        </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default WalletConnect;
